// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Calendar__ExportController from "./calendar/export_controller.js"
application.register("calendar--export", Calendar__ExportController)

import Calendar__ExportLinkController from "./calendar/export_link_controller.js"
application.register("calendar--export-link", Calendar__ExportLinkController)

import Calendar__LoadingController from "./calendar/loading_controller.js"
application.register("calendar--loading", Calendar__LoadingController)

import Calendar__TeamDeploymentController from "./calendar/team_deployment_controller.js"
application.register("calendar--team-deployment", Calendar__TeamDeploymentController)

import CalendarController from "./calendar_controller.js"
application.register("calendar", CalendarController)

import ChartController from "./chart_controller.js"
application.register("chart", ChartController)

import ClickableController from "./clickable_controller.js"
application.register("clickable", ClickableController)

import DelayedJobsController from "./delayed_jobs_controller.js"
application.register("delayed-jobs", DelayedJobsController)

import Duties__FormController from "./duties/form_controller.js"
application.register("duties--form", Duties__FormController)

import FlatpickrController from "./flatpickr_controller.js"
application.register("flatpickr", FlatpickrController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import ReassignSlotsController from "./reassign_slots_controller.js"
application.register("reassign-slots", ReassignSlotsController)

import RosterShift__LocumController from "./roster_shift/locum_controller.js"
application.register("roster-shift--locum", RosterShift__LocumController)

import Rota__DutiesController from "./rota/duties_controller.js"
application.register("rota--duties", Rota__DutiesController)

import Rota__ShiftController from "./rota/shift_controller.js"
application.register("rota--shift", Rota__ShiftController)

import Rota__WeekdayController from "./rota/weekday_controller.js"
application.register("rota--weekday", Rota__WeekdayController)

import Rota__WeeksAssignmentController from "./rota/weeks_assignment_controller.js"
application.register("rota--weeks-assignment", Rota__WeeksAssignmentController)

import ShiftSwap__CreateController from "./shift_swap/create_controller.js"
application.register("shift-swap--create", ShiftSwap__CreateController)

import ShiftSwap__ShiftCoverController from "./shift_swap/shift_cover_controller.js"
application.register("shift-swap--shift-cover", ShiftSwap__ShiftCoverController)

import ShiftSwap__ShiftCoverPopoverController from "./shift_swap/shift_cover_popover_controller.js"
application.register("shift-swap--shift-cover-popover", ShiftSwap__ShiftCoverPopoverController)

import ShiftSwap__ShiftSelectorController from "./shift_swap/shift_selector_controller.js"
application.register("shift-swap--shift-selector", ShiftSwap__ShiftSelectorController)

import ShiftSwap__WrapperController from "./shift_swap/wrapper_controller.js"
application.register("shift-swap--wrapper", ShiftSwap__WrapperController)

import TabsController from "./tabs_controller.js"
application.register("tabs", TabsController)

import User__TeamFormController from "./user/team_form_controller.js"
application.register("user--team-form", User__TeamFormController)

import User__TeamMembershipController from "./user/team_membership_controller.js"
application.register("user--team-membership", User__TeamMembershipController)
